import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '@services/login/login.service';
import { PaginatorService } from '@services/paginator/paginator.service';

@Injectable()
export class AuthGuardService  {
  private loginService = inject(LoginService);
  private router = inject(Router);
  private paginatorService = inject(PaginatorService);

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    throw new Error('Metodo no implementado');
  }


  canActivate
  (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (this.loginService.isAuthenticated()) {
      // Auditoría QA (2026-08-05): cargarAsync() ya no se dispara desde AppComponent para
      // rutas públicas (ver app.component.ts) — se mueve acá para que el parámetro
      // ItemsPorPagina se cargue apenas el usuario entra a la primera ruta protegida,
      // tanto en un refresh de página ya logueado como en una navegación SPA recién logueado
      // (cargarAsync() es idempotente, solo pega al backend la primera vez).
      this.paginatorService.cargarAsync();
      return true;
    } else {
      this.router.navigate(['/login'],{
      queryParams: {returnUrl: state.url}})
      this.loginService.logout()
      return false;
    }
  }

}
